import React, { useEffect, createRef, useContext } from 'react'
import { ModalContext } from './ModalContext'
import "./Modal.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const modalBackground = createRef()
const content = createRef()

function Modal(props) {
    const modals = useContext(ModalContext)

    useEffect(()=>{
        const clickOutside = (e) =>{
            if(modalBackground?.current.contains(e.target) && !content.current.contains(e.target)){
                setShowModal(false)
            }
        }
        const keyPressDown = (e) =>{
            // Press esc to dismiss
            if (e.keyCode === 27){
                setShowModal(false)
            }
        }
        if(!props.disableBackDrop){
            document.addEventListener('mousedown', clickOutside, false)
            document.addEventListener('keydown', keyPressDown, false)
        }

        return(()=>{
            document.removeEventListener('mousedown', clickOutside, false)
            document.removeEventListener('keydown', keyPressDown, false)
        })
    },[])

    const setShowModal = (val) =>{
        modals.setShow(val)
    }

    return (
        <div 
        id="modal"
        ref={modalBackground}
        style={{
            display: props.isShow ? "block": "none",
        }}>
            <div className="content"
            ref={content}
            style={{
                color: props.isDark ? "white": "black",
                backgroundColor: props.isDark ? "black": "white"
            }}>
                { props.isShowHeader ?
                <>
                    <div className="header"
                    style={{display: "flex"}}
                    >
                        <div>
                            {props.header}
                        </div>
                        <div className="close-btn"
                        onClick={()=>setShowModal(false)}>
                            <FontAwesomeIcon icon={faTimes}/>
                        </div>
                        
                    </div>
                    <hr/>
                </>
                : null
                }
                
                { props.isShow ?
                <div>
                    {props.children}
                </div>
                : null
                }
            </div>
            
        </div>
    )
}

export default Modal
